import { loadTextures } from 'pixi.js';
import { getDebugGameWindow } from '@hexa/app/debug/getDebugGameWindow';
import { App } from '@hexa/app/App';
import { MultiplatformHandler } from '@hexa/app/multiplatform/MultiplatformHandler';
import { AzerionGameEventsManager } from './gameEvents/AzerionGameEventsManager';
import { PlatformAzerion } from './platform/PlatformAzerion';
import { getLongPlayAdScheduler } from './ads/longPlayAdScheduler';

async function main(): Promise<void> {
  const multiplatformConfig = new MultiplatformHandler();

  if (loadTextures.config) {
    Object.assign(loadTextures.config, {
      preferWorkers: false,
      preferCreateImageBitmap: false,
    });
  }

  const app = new App({
    platform: new PlatformAzerion(),
    isDev: ENVIRONMENT === 'dev',
    multiplatformConfig,
  });

  app.gameEvents = new AzerionGameEventsManager(app);
  // AZ-998: single automatic-ad timer, counting only active gameplay.
  getLongPlayAdScheduler().attachApp(app);

  // make window debug game functions are included.
  getDebugGameWindow(app);
}
main()
  .then(() => {
    // eslint-disable-next-line no-console
    console.log(
      `%c ${APP_NAME} v${APP_VERSION} (${ENVIRONMENT}-${PLATFORM}) `,
      'background: #F5842D; color: #FFFFFF; font-weight: bold;',
    );
  })
  .catch((error: unknown) => {
    // eslint-disable-next-line no-console
    console.error('An error occurred during game initialization:', error);
  });
